const { default: store } =
  process.env.REACT_APP_ENV !== 'production' ? require('./storeDev') : require('./storeProd')

// Exporting the store, then use it anywhere like store.getState() or store.dispatch()
module.exports = store()
